import { QRCodeSVG } from "qrcode.react";
import React from "react";

import faviconIcon from "@assets/icons/favicon.svg";

import { QR_CODE_SIZES } from "@is/constants";

type Props = {
  value: string;
  size?: number;
};

const QRCodeComponent = ({ value, size = QR_CODE_SIZES.Small }: Props) => {
  return (
    <QRCodeSVG
      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
      value={value}
      size={size}
      imageSettings={{
        src: `${faviconIcon}`,
        height: 24,
        width: 24,
        excavate: true,
      }}
    />
  );
};

export default QRCodeComponent;
